// StartSVG.tsx

import React from "react";

export function StartSVG({
  svgProps,
  pathProps,
}: {
  svgProps?: React.SVGProps<SVGSVGElement>;
  pathProps?: React.SVGProps<SVGPathElement>;
}) {
  return (
    <svg
      width="27"
      height="12"
      viewBox="0 0 27 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M13.5002 1.16821L14.8052 4.6949L18.3319 5.99989L14.8052 7.30488L13.5002 10.8316L12.1952 7.30488L8.66852 5.99989L12.1952 4.6949L13.5002 1.16821Z"
        fill="#EE4D37"
        {...pathProps}
      />
    </svg>
  );
}
